<div class="loading" *ngIf="!media">
  <mtg-spinner></mtg-spinner>
</div>
<ng-container *ngIf="media && media.length > 0">
  <div class="header">
    <div class="title">Фотографии</div>
    <div class="right">
      <div class="navigation" *ngIf="dataSliderComponent && dataSliderComponent.showArrows">
        <a href="javascript:;" (click)="slideLeft()">
          <mtg-svg-icon icon="icons-arrow-left"></mtg-svg-icon>
        </a>
        <a href="javascript:;" (click)="slideRight()">
          <mtg-svg-icon icon="icons-arrow-right"></mtg-svg-icon>
        </a>
      </div>
      <a [routerLink]="getLeagueMediaRoute()" class="link-all">Раздел медиа</a>
    </div>
  </div>

  <div class="photos-slider">
    <mtg-spinner *ngIf="!media"></mtg-spinner>
    <mtg-data-slider *ngIf="media" (scrolledToEnd)="loadNextPage()" #dataSliderComponent [arrowVisible]="false">
      <ng-container *ngFor="let images of media;let i = index">
        <mtg-data-slider-item>
          <mtg-game-media-images
            [images]="images"
            [mobileStyle]="false"
            [mediaRoute]="getPhotoDetailRoute()"
            [routeReplaceRoute]="false"
          ></mtg-game-media-images>
        </mtg-data-slider-item>
        <mtg-data-slider-item class="banner-slide" *ngIf="banners[getBannerId(i)]">
          <div class="banner">
            <a [href]="banners[getBannerId(i)].link | safe: 'url'" target="_blank">
              <img [src]="banners[getBannerId(i)].picture.path">
            </a>
          </div>
        </mtg-data-slider-item>
      </ng-container>
    </mtg-data-slider>
  </div>
</ng-container>
<router-outlet></router-outlet>
